export default "__VITE_ASSET__CPyuiq2j__"